import { msAPI } from "./index.js";

export async function barcodeLookup(upc, opts = {}) {
  const trimmed = String(upc || "").trim();
  const payload = {
    upc: trimmed,
    force_refetch: Boolean(opts.force_refetch),
    additional_clue: String(opts.additional_clue || "").trim(),
    cache_image_url: String(opts.cache_image_url || "").trim(),
  };
  try {
    return (await msAPI.post("admin/barcode_lookup", payload)).data;
  } catch (e) {
    if (e.response?.status === 405) {
      return (await msAPI.get("admin/barcode_lookup", { params: payload })).data;
    }
    throw e;
  }
}

export async function createAdminProduct(payload) {
  return (await msAPI.post("dashboard/admin/product", payload)).data;
}

export async function getAdminAvailableCategories() {
  try {
    return (await msAPI.get("admin/available-categories")).data;
  } catch (e) {
    if (e.response?.status === 404 || e.response?.status === 405) {
      return (await msAPI.get("merchant/available-categories")).data;
    }
    throw e;
  }
}

export async function searchUpcDatabase({
  title = "",
  subtitle = "",
  sku_id = "",
  product_id = "",
  page = 1,
} = {}) {
  return (
    await msAPI.get("admin/upc-database/search", {
      params: { title, subtitle, sku_id, product_id, page, debug: 1 },
    })
  ).data;
}

export async function patchAdminProductUpc(skuId, upc_code) {
  return (await msAPI.patch(`admin/product/${encodeURIComponent(skuId)}`, { upc_code })).data;
}

export async function updateAdminProduct(skuId, payload) {
  return (await msAPI.patch(`admin/product/${encodeURIComponent(skuId)}`, payload)).data;
}
